import { Stack, Typography, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { Strings } from "@app/constants";
import { useResponsive } from "@app/hooks";
import { CarSearchBar } from "./cars-search-bar";

const HeroBanner = () => {
  const isMobile = useResponsive("down", "md");
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Stack
      position="absolute"
      width="100%"
      height={"100%"}
      alignItems={"center"}
      justifyContent={"start"}
      mt={isMobile ? 5 : 10}
      gap={isMobile ? 5 : 10}
    >
      <Typography
        sx={{
          color: theme.palette.common.white,
          fontWeight: "bold",
          fontFamily: "Abril Fatface",
          fontSize: isMobile ? 28 : 75,
          textAlign: "center",
          textShadow: `0px 2px 6px rgba(0, 0, 0, 0.6)`,
        }}
      >
        {Strings.home.findYourRide}
      </Typography>
      <Stack
        sx={{
          alignItems: "center",
          alignSelf: "center",
          width: "100%",
          height: 200, 
          mt: isMobile ? 0 : 5,
        }}
      >
        <CarSearchBar />
      </Stack>
    </Stack>
  );
};

export { HeroBanner };
